import { isNumber } from 'lodash';
import type { EnumLike } from './types';

export const getEnumAsIntArray = (enumLike: EnumLike) =>
	Object.values(enumLike)
		.filter((value) => isNumber(value))
		.map((value) => +value);
